import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

import {WindowSizeConsumer, TabNavigation, Button} from '@albert-io/atomic';

import AuthorDashboardActivity from './AuthorDashboardActivity/AuthorDashboardActivity.react';
import {AuthorDashboardConsumer} from './AuthorDashboardProvider/AuthorDashboardConsumer.react';
import AuthorDashboardRecent from './AuthorDashboardRecent/AuthorDashboardRecent.react';
import AuthorDashboardHeader from './AuthorDashboardHeader/AuthorDashboardHeader.react';
import AuthorDashboardMetrics from './AuthorDashboardMetrics/AuthorDashboardMetrics.react';
import AuthorDashboardNew from './AuthorDashboardActivity/AuthorDashboardNew.react';
import AuthorDashboardRefer from './AuthorDashboardRefer/AuthorDashboardRefer.react';

import stylevars from './author-dashboard.scss';

const TABS = {
  activity: 'activity',
  recent: 'recent',
  metrics: 'metrics'
};

// renders the active tab on mobile vew
const renderMobileDashboard = (component) => {
  if (!component || component === TABS.activity) {
    return <AuthorDashboardActivity />;
  }
  if (component === TABS.recent) {
    return <AuthorDashboardRecent />;
  }
  if (component === TABS.metrics) {
    return <AuthorDashboardMetrics />;
  }
  return null;
};

// handles the logic to render the dashboard if its a new author or if in mobile view
const renderDashboard = (isMobile, activeTab, isNewAuthor) => {
  if (isNewAuthor) {
    return (
      <div className={isMobile ? 'author-dashboard-body--mobile' : 'author-dashboard-body'}>
        <AuthorDashboardNew />
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className='author-dashboard-body--mobile u-mar_2'>
        <Link to='/authoring/queue' className='author-dashbaord-body__queue-link'>
          <Button color='secondary' className='author-dashboard-body__queue-button--mobile'>
            Go to authoring portal
          </Button>
        </Link>
        {renderMobileDashboard(activeTab)}
      </div>
    );
  }

  return (
    <div className='author-dashboard-body'>
      <div>
        <Link to='/authoring/queue' className='author-dashbaord-body__queue-link'>
          <Button color='secondary' className='author-dashboard-body__queue-button'>
            Go to authoring portal
          </Button>
        </Link>
      </div>
      <div className='author-dashboard-body__components-container'>
        <div className='author-dashboard-body__left'>
          <AuthorDashboardActivity />
        </div>
        <div className='author-dashboard-body__right'>
          <AuthorDashboardRecent />
          <AuthorDashboardRefer />
          <AuthorDashboardMetrics />
        </div>
      </div>
    </div>
  );
};

const AuthorDashboard = (props) => {
  const activeTab = props.location.query.active;
  return (
    <WindowSizeConsumer>
      {({viewportWidth}) => {
        const isMobile = viewportWidth <= parseInt(stylevars.mobileBreakpoint, 10);
        const shouldBreakHeader = viewportWidth <= parseInt(stylevars.headerBreakpoint, 10);
        return (
          <AuthorDashboardConsumer field='isNewAuthor'>
            {({isNewAuthor}) => (
              <div>
                <div className='author-dashboard-header'>
                  <AuthorDashboardHeader
                    isMobile={isMobile}
                    isNewAuthor={isNewAuthor}
                    shouldBreakHeader={shouldBreakHeader}
                  />
                  {isMobile && !isNewAuthor && (
                    <div className='author-dashboard-body'>
                      <TabNavigation fillWidth>
                        <TabNavigation.Tab
                          isActive={activeTab === TABS.activity || !activeTab}
                          as={Link}
                          to={`/authoring/dashboard?active=${TABS.activity}`}
                        >
                          Activity
                        </TabNavigation.Tab>
                        <TabNavigation.Tab
                          isActive={activeTab === TABS.recent}
                          as={Link}
                          to={`/authoring/dashboard?active=${TABS.recent}`}
                        >
                          Recent
                        </TabNavigation.Tab>
                        <TabNavigation.Tab
                          isActive={activeTab === TABS.metrics}
                          as={Link}
                          to={`/authoring/dashboard?active=${TABS.metrics}`}
                        >
                          Metrics
                        </TabNavigation.Tab>
                      </TabNavigation>
                    </div>
                  )}
                </div>
                {renderDashboard(isMobile, activeTab, isNewAuthor)}
              </div>
            )}
          </AuthorDashboardConsumer>
        );
      }}
    </WindowSizeConsumer>
  );
};

AuthorDashboard.propTypes = {
  location: PropTypes.object
};

export default AuthorDashboard;
